<template>
  <div id="app" v-cloak>
    <meta name="referrer" content="never">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  margin:0;
  padding:0;
  height:100%;
}
/* body{
  -webkit-animation: bgbody 1.5s ease;
  -o-animation: bgbody 1.5s ease;
  animation: bgbody 1.5s ease;
} */
.fadein{
  -webkit-animation: bgbody 1.5s ease;
  -o-animation: bgbody 1.5s ease;
  animation: bgbody 1.5s ease;
}
@keyframes bgbody {
  0%{
      opacity: 0;
      background-color: #ffffff;
  }
  100%{
      opacity: 1;
  }
}

/* .nav{
  height:40px;
  background-color: #242f3c;
} */

/* #loadOverlay{display: none;} */
</style>



// WEBPACK FOOTER //
// src/App.vue